import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6698ffad"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "name" }
const _hoisted_3 = {
  key: 0,
  class: "agencies"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, " Changer ", -1))
const _hoisted_6 = ["value"]

import { computed, onBeforeMount, ref, Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { changeAgency, useAgenciesStore, useAuthStore, useTransactionsStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'AgencySelector',
  setup(__props) {

const authStore = useAuthStore()
const agenciesStore = useAgenciesStore()

const route = useRoute()
const router = useRouter()
const opened: Ref<boolean> = ref(false)

const agencies = computed(() => agenciesStore.byName)

onBeforeMount(() => {
    agenciesStore.fetchCollection()
    document.addEventListener('click', () => {
        opened.value = false
    })
})

const showAgencies = async () => {
    opened.value = true
}
const setAgency = async (id: string) => {
    await changeAgency(id)
    opened.value = false
    
    if (route.name === 'home') {
        useTransactionsStore().fetchImportantCollection()
    }
    else {
        router.push('/')
        
    }
}
        
     

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "agency",
    onClick: _withModifiers(showAgencies, ["stop"])
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(authStore).user.agency?.displayName || _unref(authStore).user.agency?.name), 1),
    (agencies.value.length > 1)
      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          icon: "angle-down"
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (opened.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agencies.value, (agency) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "agency-link",
                  key: agency.id,
                  onClick: ($event: any) => (setAgency(agency.id))
                }, _toDisplayString(agency.displayName || agency.name), 9, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (agencies.value.length > 1)
      ? (_openBlock(), _createElementBlock("select", {
          key: 1,
          name: "",
          id: "",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (setAgency(($event.target as any).value)))
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agencies.value, (agency) => {
            return (_openBlock(), _createElementBlock("option", {
              value: agency.id,
              key: 'opt' + agency.id
            }, _toDisplayString(agency.displayName || agency.name), 9, _hoisted_6))
          }), 128))
        ], 32))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})